import http from 'plugins/axios';

function query(params = {}) {
  return Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== '')
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
}

export default {
  enums() {
    return http.get({ url: '/ta/admin/tenant/vip/user/enums' });
  },
  page(params) {
    return http.get({ url: `/ta/admin/tenant/vip/user/page?${query(params)}` });
  },
  changeRecordPage(params) {
    return http.get({ url: `/ta/admin/tenant/vip/user/change-record/page?${query(params)}` });
  },
};
